import Joi from 'joi';
import blockAppearanceSchema from '@utils/validate/blocksSchemes/blockAppearanceSchema';
const liveChatBlockSchema = Joi.object({
  type: Joi.string().valid('liveChatBlock').required(),
  code: Joi.string().allow('', null).required(),
  chatType: Joi.string().allow('', null).required(),
  header: Joi.string().allow('', null).required(),
  message: Joi.string().allow('', null).required(),
  link: Joi.string().required(),
  ...blockAppearanceSchema
}).unknown(true);
export default liveChatBlockSchema;